export default __webpack_public_path__ + "static/media/queshengye-shiyan.0f96261b.png";